// source: witbooking/backoffice/taxation/v1/taxation_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.GetTaxationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.GetTaxationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.Taxation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.Taxation.TaxationPreference', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.Taxation.TaxationTypology', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.TaxationRestrictions', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.TaxationThreshold', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.TaxationTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.TaxationWrapper', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.TaxationWrapper.TaxationCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.displayName = 'proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.displayName = 'proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.displayName = 'proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.displayName = 'proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.displayName = 'proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.displayName = 'proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.GetTaxationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.displayName = 'proto.witbooking.backoffice.taxation.v1.GetTaxationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.GetTaxationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.displayName = 'proto.witbooking.backoffice.taxation.v1.GetTaxationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.displayName = 'proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.displayName = 'proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.TaxationTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.TaxationTranslation.displayName = 'proto.witbooking.backoffice.taxation.v1.TaxationTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.TaxationThreshold, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.TaxationThreshold.displayName = 'proto.witbooking.backoffice.taxation.v1.TaxationThreshold';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.TaxationRestrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.displayName = 'proto.witbooking.backoffice.taxation.v1.TaxationRestrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.Taxation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.taxation.v1.Taxation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.Taxation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.Taxation.displayName = 'proto.witbooking.backoffice.taxation.v1.Taxation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.taxation.v1.TaxationWrapper.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.taxation.v1.TaxationWrapper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxation.v1.TaxationWrapper.displayName = 'proto.witbooking.backoffice.taxation.v1.TaxationWrapper';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxation: (f = msg.getTaxation()) && proto.witbooking.backoffice.taxation.v1.TaxationWrapper.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest;
  return proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.taxation.v1.TaxationWrapper;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.TaxationWrapper.deserializeBinaryFromReader);
      msg.setTaxation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.taxation.v1.TaxationWrapper.serializeBinaryToWriter
    );
  }
};


/**
 * optional TaxationWrapper taxation = 1;
 * @return {?proto.witbooking.backoffice.taxation.v1.TaxationWrapper}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.prototype.getTaxation = function() {
  return /** @type{?proto.witbooking.backoffice.taxation.v1.TaxationWrapper} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxation.v1.TaxationWrapper, 1));
};


/**
 * @param {?proto.witbooking.backoffice.taxation.v1.TaxationWrapper|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} returns this
*/
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.prototype.setTaxation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest} returns this
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.prototype.clearTaxation = function() {
  return this.setTaxation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationRequest.prototype.hasTaxation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse;
  return proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.CreateTaxationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxation: (f = msg.getTaxation()) && proto.witbooking.backoffice.taxation.v1.TaxationWrapper.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest;
  return proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.taxation.v1.TaxationWrapper;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.TaxationWrapper.deserializeBinaryFromReader);
      msg.setTaxation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.taxation.v1.TaxationWrapper.serializeBinaryToWriter
    );
  }
};


/**
 * optional TaxationWrapper taxation = 1;
 * @return {?proto.witbooking.backoffice.taxation.v1.TaxationWrapper}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.prototype.getTaxation = function() {
  return /** @type{?proto.witbooking.backoffice.taxation.v1.TaxationWrapper} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxation.v1.TaxationWrapper, 1));
};


/**
 * @param {?proto.witbooking.backoffice.taxation.v1.TaxationWrapper|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} returns this
*/
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.prototype.setTaxation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest} returns this
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.prototype.clearTaxation = function() {
  return this.setTaxation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationRequest.prototype.hasTaxation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse;
  return proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.UpdateTaxationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest;
  return proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest} returns this
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse;
  return proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.DeleteTaxationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.GetTaxationRequest;
  return proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.taxation.v1.GetTaxationRequest} returns this
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxation: (f = msg.getTaxation()) && proto.witbooking.backoffice.taxation.v1.TaxationWrapper.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.GetTaxationResponse;
  return proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.taxation.v1.TaxationWrapper;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.TaxationWrapper.deserializeBinaryFromReader);
      msg.setTaxation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.taxation.v1.TaxationWrapper.serializeBinaryToWriter
    );
  }
};


/**
 * optional TaxationWrapper taxation = 1;
 * @return {?proto.witbooking.backoffice.taxation.v1.TaxationWrapper}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.prototype.getTaxation = function() {
  return /** @type{?proto.witbooking.backoffice.taxation.v1.TaxationWrapper} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxation.v1.TaxationWrapper, 1));
};


/**
 * @param {?proto.witbooking.backoffice.taxation.v1.TaxationWrapper|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse} returns this
*/
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.prototype.setTaxation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.GetTaxationResponse} returns this
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.prototype.clearTaxation = function() {
  return this.setTaxation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.GetTaxationResponse.prototype.hasTaxation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest;
  return proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    feesList: jspb.Message.toObjectList(msg.getFeesList(),
    proto.witbooking.backoffice.taxation.v1.Taxation.toObject, includeInstance),
    taxesList: jspb.Message.toObjectList(msg.getTaxesList(),
    proto.witbooking.backoffice.taxation.v1.Taxation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse;
  return proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.taxation.v1.Taxation;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.Taxation.deserializeBinaryFromReader);
      msg.addFees(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.taxation.v1.Taxation;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.Taxation.deserializeBinaryFromReader);
      msg.addTaxes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFeesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.taxation.v1.Taxation.serializeBinaryToWriter
    );
  }
  f = message.getTaxesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.taxation.v1.Taxation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Taxation fees = 1;
 * @return {!Array<!proto.witbooking.backoffice.taxation.v1.Taxation>}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.getFeesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.taxation.v1.Taxation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.taxation.v1.Taxation, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.taxation.v1.Taxation>} value
 * @return {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse} returns this
*/
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.setFeesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.Taxation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.addFees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.taxation.v1.Taxation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse} returns this
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.clearFeesList = function() {
  return this.setFeesList([]);
};


/**
 * repeated Taxation taxes = 2;
 * @return {!Array<!proto.witbooking.backoffice.taxation.v1.Taxation>}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.getTaxesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.taxation.v1.Taxation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.taxation.v1.Taxation, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.taxation.v1.Taxation>} value
 * @return {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse} returns this
*/
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.setTaxesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.Taxation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation}
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.addTaxes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.taxation.v1.Taxation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse} returns this
 */
proto.witbooking.backoffice.taxation.v1.FindTaxationsResponse.prototype.clearTaxesList = function() {
  return this.setTaxesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.TaxationTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation}
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.TaxationTranslation;
  return proto.witbooking.backoffice.taxation.v1.TaxationTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation}
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.TaxationTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationTranslation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.TaxationThreshold.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.toObject = function(includeInstance, msg) {
  var f, obj = {
    startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endAt: (f = msg.getEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold}
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.TaxationThreshold;
  return proto.witbooking.backoffice.taxation.v1.TaxationThreshold.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold}
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.TaxationThreshold.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_at = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold} returns this
*/
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.getEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold} returns this
*/
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.setEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationThreshold} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.clearEndAt = function() {
  return this.setEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.TaxationThreshold.prototype.hasEndAt = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationRestrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.toObject = function(includeInstance, msg) {
  var f, obj = {
    maxNights: jspb.Message.getFieldWithDefault(msg, 1, 0),
    maxAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    minAge: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationRestrictions}
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.TaxationRestrictions;
  return proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationRestrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationRestrictions}
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxNights(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinAge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationRestrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxNights();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMaxAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMinAge();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 max_nights = 1;
 * @return {number}
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.prototype.getMaxNights = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationRestrictions} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.prototype.setMaxNights = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double max_amount = 2;
 * @return {number}
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.prototype.getMaxAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationRestrictions} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.prototype.setMaxAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 min_age = 3;
 * @return {number}
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.prototype.getMinAge = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationRestrictions} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.prototype.setMinAge = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.taxation.v1.Taxation.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.Taxation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.Taxation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.Taxation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.taxation.v1.TaxationTranslation.toObject, includeInstance),
    typology: jspb.Message.getFieldWithDefault(msg, 5, 0),
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    threshold: (f = msg.getThreshold()) && proto.witbooking.backoffice.taxation.v1.TaxationThreshold.toObject(includeInstance, f),
    restriction: (f = msg.getRestriction()) && proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    preference: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.Taxation;
  return proto.witbooking.backoffice.taxation.v1.Taxation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.Taxation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.taxation.v1.TaxationTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.TaxationTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 5:
      var value = /** @type {!proto.witbooking.backoffice.taxation.v1.Taxation.TaxationTypology} */ (reader.readEnum());
      msg.setTypology(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.taxation.v1.TaxationThreshold;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.TaxationThreshold.deserializeBinaryFromReader);
      msg.setThreshold(value);
      break;
    case 9:
      var value = new proto.witbooking.backoffice.taxation.v1.TaxationRestrictions;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.deserializeBinaryFromReader);
      msg.setRestriction(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 12:
      var value = /** @type {!proto.witbooking.backoffice.taxation.v1.Taxation.TaxationPreference} */ (reader.readEnum());
      msg.setPreference(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.Taxation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.Taxation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.Taxation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.witbooking.backoffice.taxation.v1.TaxationTranslation.serializeBinaryToWriter
    );
  }
  f = message.getTypology();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getThreshold();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.taxation.v1.TaxationThreshold.serializeBinaryToWriter
    );
  }
  f = message.getRestriction();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.witbooking.backoffice.taxation.v1.TaxationRestrictions.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.TaxationTypology = {
  PER_PERSON: 0,
  PER_PERSON_PER_NIGHT: 1,
  PER_STAY: 2,
  PER_STAY_PER_NIGHT: 3,
  PERCENTAGE: 4,
  BALEARIC: 5
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.TaxationPreference = {
  INCLUDED: 0,
  EXCLUDED: 1,
  INCLUDED_IN_CHECKOUT: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated TaxationTranslation translations = 4;
 * @return {!Array<!proto.witbooking.backoffice.taxation.v1.TaxationTranslation>}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.taxation.v1.TaxationTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.taxation.v1.TaxationTranslation, 4));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.taxation.v1.TaxationTranslation>} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
*/
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationTranslation}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.backoffice.taxation.v1.TaxationTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional TaxationTypology typology = 5;
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation.TaxationTypology}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getTypology = function() {
  return /** @type {!proto.witbooking.backoffice.taxation.v1.Taxation.TaxationTypology} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.Taxation.TaxationTypology} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setTypology = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional double amount = 6;
 * @return {number}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional TaxationThreshold threshold = 8;
 * @return {?proto.witbooking.backoffice.taxation.v1.TaxationThreshold}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getThreshold = function() {
  return /** @type{?proto.witbooking.backoffice.taxation.v1.TaxationThreshold} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxation.v1.TaxationThreshold, 8));
};


/**
 * @param {?proto.witbooking.backoffice.taxation.v1.TaxationThreshold|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
*/
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setThreshold = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.clearThreshold = function() {
  return this.setThreshold(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.hasThreshold = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TaxationRestrictions restriction = 9;
 * @return {?proto.witbooking.backoffice.taxation.v1.TaxationRestrictions}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getRestriction = function() {
  return /** @type{?proto.witbooking.backoffice.taxation.v1.TaxationRestrictions} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxation.v1.TaxationRestrictions, 9));
};


/**
 * @param {?proto.witbooking.backoffice.taxation.v1.TaxationRestrictions|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
*/
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setRestriction = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.clearRestriction = function() {
  return this.setRestriction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.hasRestriction = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
*/
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
*/
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional TaxationPreference preference = 12;
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation.TaxationPreference}
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.getPreference = function() {
  return /** @type {!proto.witbooking.backoffice.taxation.v1.Taxation.TaxationPreference} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.witbooking.backoffice.taxation.v1.Taxation.TaxationPreference} value
 * @return {!proto.witbooking.backoffice.taxation.v1.Taxation} returns this
 */
proto.witbooking.backoffice.taxation.v1.Taxation.prototype.setPreference = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.TaxationCase = {
  TAXATION_NOT_SET: 0,
  FEE: 1,
  TAX: 2
};

/**
 * @return {proto.witbooking.backoffice.taxation.v1.TaxationWrapper.TaxationCase}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.getTaxationCase = function() {
  return /** @type {proto.witbooking.backoffice.taxation.v1.TaxationWrapper.TaxationCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.taxation.v1.TaxationWrapper.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxation.v1.TaxationWrapper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.toObject = function(includeInstance, msg) {
  var f, obj = {
    fee: (f = msg.getFee()) && proto.witbooking.backoffice.taxation.v1.Taxation.toObject(includeInstance, f),
    tax: (f = msg.getTax()) && proto.witbooking.backoffice.taxation.v1.Taxation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxation.v1.TaxationWrapper;
  return proto.witbooking.backoffice.taxation.v1.TaxationWrapper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.taxation.v1.Taxation;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.Taxation.deserializeBinaryFromReader);
      msg.setFee(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.taxation.v1.Taxation;
      reader.readMessage(value,proto.witbooking.backoffice.taxation.v1.Taxation.deserializeBinaryFromReader);
      msg.setTax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxation.v1.TaxationWrapper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFee();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.taxation.v1.Taxation.serializeBinaryToWriter
    );
  }
  f = message.getTax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.taxation.v1.Taxation.serializeBinaryToWriter
    );
  }
};


/**
 * optional Taxation fee = 1;
 * @return {?proto.witbooking.backoffice.taxation.v1.Taxation}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.getFee = function() {
  return /** @type{?proto.witbooking.backoffice.taxation.v1.Taxation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxation.v1.Taxation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.taxation.v1.Taxation|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper} returns this
*/
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.setFee = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.taxation.v1.TaxationWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.clearFee = function() {
  return this.setFee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.hasFee = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Taxation tax = 2;
 * @return {?proto.witbooking.backoffice.taxation.v1.Taxation}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.getTax = function() {
  return /** @type{?proto.witbooking.backoffice.taxation.v1.Taxation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxation.v1.Taxation, 2));
};


/**
 * @param {?proto.witbooking.backoffice.taxation.v1.Taxation|undefined} value
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper} returns this
*/
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.setTax = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.taxation.v1.TaxationWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxation.v1.TaxationWrapper} returns this
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.clearTax = function() {
  return this.setTax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxation.v1.TaxationWrapper.prototype.hasTax = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.witbooking.backoffice.taxation.v1);
